import {ADMIN_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_MAINTENANCE_SETTINGS = ADMIN_ROOT_API_URL + "/get_maintenance_settings";
export const UPDATE_MAINTENANCE_SETTINGS = ADMIN_ROOT_API_URL + "/update_maintenance_settings";